// extracted by mini-css-extract-plugin
export default {"row":"create-transaction_row__lNO0+","rowField":"create-transaction_rowField__OJ+ha","fullWidth":"create-transaction_fullWidth__EtBvm"};